import { useQuery } from '@apollo/client';
import { FIELD_JOB_PUBLISHING_DATE } from '~/jobiqo/components/Job/Form/components/PublishingDateInput';
import DEFAULT_JOB_DURATION from '~/jobiqo/components/Job/graphql/queries/maximumJobDuration.gql';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

/**
 * It returns the maximum duration of a job, based on the job type.
 * @param {string} jobType - The type of job you want to get the default duration
 * for.
 * @returns The default duration of a job.
 */
export function useJobDurationInfo(
  jobType: string,
): {
  maximumJobDuration: number;
} | null {
  const { JOBS } = useFrontendConfig();

  if (JOBS.SCHEDULED_JOB_FEATURE_ACTIVE) {
    const { data } = useQuery(DEFAULT_JOB_DURATION, {
      variables: {
        name: 'node',
        bundle: jobType,
      },
      fetchPolicy: 'no-cache',
    });

    return {
      maximumJobDuration: data?.definition.fields.find(
        (field) => field.id === FIELD_JOB_PUBLISHING_DATE,
      )?.maximumJobDuration,
    };
  }

  return null;
}
